import { makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import WorkstationStatusContent from '../../Dashboard/WorkstationStatusContent';
import OEEContent from '../../Dashboard/OEEContent';
import BackForwardButton from '../../Shared/BackForwardButton'
import { NavLink } from "react-router-dom";
import ShiftPerformanceContent from '../../Dashboard/ShiftPerformanceContent';
import DashboardMessagesContent from '../../Dashboard/WorkstationMessagesContent';
import ProgressionChart from '../../Dashboard/Charts/ProgressionChart';
import SettingsIcon from '@material-ui/icons/Settings';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import DashboardConfigurationDrawer from '../../Dashboard/DashboardConfigurationDrawer';

export default function DashboardPage(props) {
    const classes = useStyles();
    const [workstation, setWorkstation] = useState([]);
    const [previousWorkstationId, setPreviousWorkstationId] = useState(0);
    const [nextWorkstationId, setNextWorkstationId] = useState(0);

    if (workstation !== props.workstation.workstations.find(x => String(x.id) === props.match.params.id)) {
        setWorkstation(props.workstation.workstations.find(x => String(x.id) === props.match.params.id))
        setPreviousWorkstationId(0)
        setNextWorkstationId(0)
    }
    console.log(nextWorkstationId)
    console.log(workstation.id)


    let indexCurrentWorkstation = props.workstation.workstations.indexOf(workstation);

    if (indexCurrentWorkstation > 0) {
        if (previousWorkstationId !== props.workstation.workstations[indexCurrentWorkstation - 1].id) {
            setPreviousWorkstationId(props.workstation.workstations[indexCurrentWorkstation - 1].id)
        }
    }
    if (indexCurrentWorkstation < props.workstation.workstations.length - 1) {
        if (nextWorkstationId !== props.workstation.workstations[indexCurrentWorkstation + 1].id) {
            setNextWorkstationId(props.workstation.workstations[indexCurrentWorkstation + 1].id)
        }
    }

    // if (indexCurrentWorkstation > 0) {
    //     if (previousWorkstationId !== props.workstation.workstations[indexCurrentWorkstation - 1].id) {
    //         setPreviousWorkstationId(props.workstation.workstations[indexCurrentWorkstation - 1].id)
    //     }
    // }
    // if (indexCurrentWorkstation < props.workstation.workstations.length - 1) {
    //     if (nextWorkstationId !== props.workstation.workstations[indexCurrentWorkstation + 1].id) {
    //         setNextWorkstationId(props.workstation.workstations[indexCurrentWorkstation + 1].id)
    //     }
    // }

    const openDashboardConfigurationDrawer = (open) => {
        props.actions.setDashboardConfigurationDrawerOpen(open);
    }

    return <div className={classes.background}>{workstation ? <React.Fragment>
        <div className={classes.header}><React.Fragment><div><button className={classes.title}>Line {workstation.id} dashboard</button></div>
            <button className={classes.settingsButton} onClick={() => openDashboardConfigurationDrawer(true)}><SettingsIcon className={classes.settingsIcon}></SettingsIcon></button>
            {nextWorkstationId === 11 ? <React.Fragment></React.Fragment>
                :
                <div className={classes.next}>
                    <NavLink className={classes.navButton} to={`/dashboard/${(String(nextWorkstationId))}`}>
                        <BackForwardButton direction={'forward'}></BackForwardButton>
                    </NavLink>
                </div>}

            {previousWorkstationId !== 0 ? <div className={classes.previous}>
                <NavLink className={classes.navButton} to={`/dashboard/${(String(previousWorkstationId))}`}>
                    <BackForwardButton textOverride={"previous"} direction={'Back'}></BackForwardButton>
                </NavLink>
            </div> : <React.Fragment></React.Fragment>}
        </React.Fragment>
        </div>
        <div className={classes.main}>
            <div className={classes.leftDashboard}>
                {props.dashboard.statusBoard ? <div className={classes.statusContainer}>
                    <WorkstationStatusContent workStation={workstation} {...props} actions={props.actions} status={props.workstation.workstationStatusses.find(x => x.id === workstation.status)} statusses={props.workstation.workstationStatusses}></WorkstationStatusContent>
                </div> : <React.Fragment></React.Fragment>}
                {props.dashboard.shiftPerformanceBoard ? <div className={classes.shiftPerformanceContainer}>
                    <ShiftPerformanceContent workstation={workstation}></ShiftPerformanceContent>
                </div> : <React.Fragment></React.Fragment>}
            </div>
            {props.dashboard.OEEBoard ? <div className={classes.middleDashboard}>
                <OEEContent workstation={workstation}></OEEContent>
            </div> : <React.Fragment></React.Fragment>}
            <div className={classes.rightDashboard}>
                {props.dashboard.progressionBoard ? <ProgressionChart progressions={props.dashboard.progressions} workstation={workstation}></ProgressionChart> : <React.Fragment></React.Fragment>}
                {props.dashboard.messagesBoard ? <DashboardMessagesContent workstation={workstation}></DashboardMessagesContent> : <React.Fragment></React.Fragment>}
            </div>
        </div>
        <DashboardConfigurationDrawer openDrawer={openDashboardConfigurationDrawer} drawerOpen={props.dashboard.dashboardConfigurationDrawerOpen} {...props} actions={props.actions}></DashboardConfigurationDrawer>

    </React.Fragment> :
        <React.Fragment></React.Fragment>}
    </div>
}

const useStyles = makeStyles({
    main: {
        width: "100%",
        height: "calc(100% - 55px)"
    },
    leftDashboard: {
        width: "38%",
        float: "left"
    },
    rightDashboard: {
        height: "fit-content",
        borderRadius: "6px",
        marginLeft: "10px",
        width: "calc(60% - 200px)",
        float: "left"
    },
    middleDashboard: {
        width: "200px",
        height: "fit-content",
        backgroundColor: "white",
        marginLeft: "10px",
        borderRadius: "6px",
        float: "left"
    },
    title: {
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: "#000000",
        float: "left",
        border: "none",
        outline: "none"
    },
    statusContainer: {
        height: "auto",
        backgroundColor: "white",
        marginBottom: "10px",
        padding: "20px",
        borderRadius: "6px"
    },
    shiftPerformanceContainer: {
        height: "fit-content",
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px",
        paddingBottom: "57px"
    },
    background: {
        padding: "20px",
        marginTop: "40px"
    },
    header: {
        height: "55px"
    },
    previous: {
        float: "right",
    },
    nextButton: {
        float: "right"
    },
    navButton: {
        textDecoration: "none"
    },
    next: {
        float: "right"
    },

    messages: {
        backgroundColor: "white",
        borderRadius: "6px",
        padding: "20px"
    },
    settingsIcon: {
        color: FlagstoneTheme.palette.primary.main,
    },
    settingsButton: {
        border: "none",
        outline: "none",
        cursor: "pointer"
    }

});